import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useChallenge = (id) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['challenge', id],
    queryFn: async () => {
      const result = await restClient({ url: `${prefix}/challenge-definitions/${id}`});
      return result;
    },
    enabled: !!id,
    staleTime: 0,
    cacheTime: 0,
  });
};
